import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUsers } from "react-icons/fa";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import he from "he";
import Nav from "../Nav";
import TravLadhak from "../TravLadhak";
import Footer from "../Footer";
import Seo from "../../Seo/Seo";
import { toMetaDescription, useCanonicalUrl } from "../../Seo/seoUtils";
import { buildPackageJsonLd } from "../../Seo/jsonLd";
import { SITE_NAME } from "../../Seo/seoConfig";
import TourDatePicker, { formatApiDate, useTourDate } from "./TourDatePicker";
import { buildMapEmbedSrc, buildMapDirectionsUrl } from "../../Maps/mapUtils";
import { NavLink } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faStar,
  faHotel,
  faCar,
  faPersonHiking,
  faTag,
  faSun, faChevronDown,
  faLocation,
  faLocationPin,
  faCalendar,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import { Facebook, Instagram, Twitter } from "lucide-react";
import Bike2 from "../../../assets/Images/bike2.png";
import Slider from "react-slick";
import wlogo from "../../../assets/Images/White_TCL_logo.png";
import wha from "../../../assets/Images/wha.jpg";
import "./BikePackage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const DetailHotelPackage = () => {
  const [activeDay, setActiveDay] = useState(1);
  const [detailData, setDetailData] = useState(null);
  const [relatedResorts, setRelatedResorts] = useState([]);
  const [bikePackages, setBikePackages] = useState([]);
  const [hotelPackages, setHotelPackages] = useState([]);
  const [isToggled, setIsToggled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [persons, setPersons] = useState(1);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const toggleDay = (day) => {
    setActiveDay(prev => (prev === day ? 0 : day));
  };

  const { id } = useParams(); // this is now a name-based slug, e.g. "hotel-chasta"
  const location = useLocation();
  const canonicalUrl = useCanonicalUrl();
  const tourDatePicker = useTourDate(detailData?.days);
  const { tourDate, tourEndDate } = tourDatePicker;
  console.log("iddii-", id)

  // Turn a package name into the same slug used in the URL
  const slugify = (str) =>
    str
      ?.toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") // any run of non-alphanumerics -> single dash
      .replace(/^-+|-+$/g, "");    // trim leading/trailing dashes
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();
        const allPackages = result?.data || [];

        console.log("All Packages:", allPackages);
        console.log("URL param id:", id);

        // Match by name-based slug from the URL
        const currentDetail = allPackages.filter(pkg => slugify(pkg.name) === id);
        console.log("Current Detail:", currentDetail);

        // Set the first matched item or null
        setDetailData(currentDetail[0] || null);

        // Related resorts (hotels that are not the current one)
        const related = allPackages.filter(
          pkg =>
            slugify(pkg.name) !== id &&
            pkg?.category?.name?.toLowerCase() === "hotels"
        );
        setRelatedResorts(related.slice(0, 4));

      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, [id]);


  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const closeNavbar = () => {
    setIsToggled(false);
  };
  const navigate = useNavigate();


  const handleLogOut = () => {
    alert("You are Logging out...");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsToggled(false);
    setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  if (!detailData) return <p className="text-center mt-5">Loading package details...</p>;

  const handleBookClick = () => {
    if (!tourDate) {
      tourDatePicker.setOpen(true);
      return;
    }
    const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn) {
      setShowModal(true); // show confirmation modal
    } else {
      // Save current path before redirecting
      sessionStorage.setItem("redirectAfterLogin", location.pathname);
      navigate("/login");
    }
  };
  const token = sessionStorage.getItem("token");

  const handleConfirmBooking = async () => {
    setShowModal(false); // Close confirmation modal

    const payload = {
      token: token,
      PackageId: detailData?.id,  // real numeric package id (URL param is a name slug)
      Amount: (detailData?.price?.[0] * persons).toString(),
      FromDate: formatApiDate(tourDate),
      ToDate: tourEndDate ? formatApiDate(tourEndDate) : null,
      Persons: persons,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}new-booking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setShowSuccessModal(true); // Show success message
        console.log(response);
      } else {
        alert("Booking failed. Please try again.");
      }
    } catch (error) {
      console.error("Booking error:", error);
      alert("An error occurred. Please try again.");
    }
  };


  const isCurrent = detailData && slugify(detailData.name) === id;

  // `location` is a destination name ("Leh", "Nubra"), not a street address, so
  // pair it with the hotel name to give Google's geocoder its best chance.
  const mapQuery = [detailData?.name, detailData?.location, "Ladakh, India"]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <Seo
        title={isCurrent ? detailData.meta_title || `${detailData.name} | ${SITE_NAME}` : undefined}
        description={
          isCurrent
            ? detailData.meta_description || toMetaDescription(detailData.overview, 160)
            : undefined
        }
        image={detailData?.image?.[0]}
        type="product"
        jsonLd={isCurrent ? buildPackageJsonLd(detailData, canonicalUrl) : null}
      />

      <Nav />



      <div className="container-fluid mt-4">
        <div className="card border mb-4">
          <div className="row gx-3 mb-4">
            {/* Left Column - Main Image */}
            <div className="col-md-8">
              <img
                src={detailData?.image?.[0] || "/placeholder.svg"}
                alt={detailData?.name}
                className="img-fluid rounded w-100 p-2"
                style={{ height: "100%", maxHeight: "550px", objectFit: "cover", }}
              />
            </div>

            {/* Right Column - Collage Style Two Stacked Images */}
            <div className="col-md-4 d-flex flex-column p-2 gap-3">
              <img
                src={detailData?.image?.[1] || "/placeholder.svg"}
                alt={`${detailData?.name} hotel image`}
                className="img-fluid rounded w-100"
                style={{ height: "270px", objectFit: "cover" }}
              />
              <img
                src={detailData?.image?.[2] || "/placeholder.svg"}
                alt={`Image of ${detailData?.name}`}
                className="img-fluid rounded w-100"
                style={{ height: "270px", objectFit: "cover" }}
              />
            </div>
          </div>


          <div className="card-body px-0">
            <div className="row justify-content-around">

              {/* LEFT SIDE - TOUR DETAILS */}
              <div className="col-md-8">
                <h1 className="fw-bold mb-3">{detailData?.name}</h1>
                <p
                  className="text-muted small"
                  dangerouslySetInnerHTML={{
                    __html: he.decode(detailData?.overview || ""),
                  }}
                ></p>
                <div className="d-flex gap-3 mt-3 mb-4 flex-wrap">
                  <span className="badge bg-light text-dark border">Trip Duration: {detailData?.days || 'N/A'} days</span>
                  <span className="badge bg-light text-dark border">Trip Type: {detailData?.category.name || 'Bike Ride'}</span>
                  <span className="badge bg-light text-dark border">Destination: {detailData?.location || 'Unknown'}</span>
                </div>
              </div>

              {/* RIGHT SIDE - STACKED CARDS */}
              <div className="col-md-3 d-flex flex-column gap-3">
                <div className="card shadow-sm">
                  <div
                    className="card-body d-flex flex-column justify-content-center align-items-center text-center"
                    style={{ padding: "1rem" }}
                  >
                    <p className="card-title mb-3" style={{ fontSize: "1rem" }}>Details</p>

                    <TourDatePicker picker={tourDatePicker} />

                    <div className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between w-100">
                      <FaUsers className="text-secondary me-2" size={16} />
                      <span className="text-muted small me-2">Days:</span>
                      <span style={{ fontSize: "0.85rem" }}>{detailData?.days || 'N/A'}</span>
                    </div>

                    {/* Persons Input */}
                    <div className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between w-100">
                      <FaUsers className="text-secondary me-2" size={16} />
                      <span className="text-muted small me-2">Persons:</span>
                      <input
                        type="number"
                        min="1"
                        value={persons}
                        onChange={(e) => setPersons(parseInt(e.target.value) || 1)}
                        className="form-control form-control-sm"
                        style={{ maxWidth: "60px" }}
                      />
                    </div>

                    {/* Price Display */}
                    <div className="border rounded p-2 w-100">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="text-muted small">Price / Person:</span>
                        <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                          ₹{detailData?.price[0] || '---'}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="text-muted small">Total Price:</span>
                        <span className="fw-bold text-success" style={{ fontSize: "0.9rem" }}>
                          ₹{(detailData?.price?.[0] * persons).toLocaleString()}
                        </span>
                      </div>
                      <button
                        className="btn btn-dark px-3 py-1 rounded-pill w-100"
                        style={{ fontSize: "0.8rem" }}
                        onClick={handleBookClick}
                      >
                        Book
                      </button>
                      {/* Modal */}
                      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                          <Modal.Title>Confirm Booking</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Do you want to proceed with booking this package?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                          </Button>
                          <Button variant="primary" onClick={handleConfirmBooking}>
                            Yes, Book Now
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                        <Modal.Header closeButton>
                          <Modal.Title>Booking Confirmed</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Thank you for your booking! Our team will contact you shortly.
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <div className="row justify-content-around align-items-start gx-4">

            {/* Left Column: Amenities + Hotel Info stacked vertically */}
            <div className="col-md-8">
              {/* Amenities */}
              <div className="p-4 border rounded bg-white mb-4">
                <h2 className="mb-4 border-bottom pb-2">Amenities</h2>
                {detailData?.trip_highlight && detailData.trip_highlight.length > 0 ? (
                  <ul className="list-unstyled">
                    {detailData.trip_highlight.map((item, index) => (
                      <li key={index} className="mb-2 text-dark">{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-muted">No amenities listed.</p>
                )}
              </div>

              {detailData?.pricing_table && detailData.pricing_table.length > 0 ? (
                <div className="p-4 border rounded bg-white mb-4">
                  <h2 className="mb-4 border-bottom pb-2">Pricing Options</h2>
                  {detailData.pricing_table.map((dur, di) => (
                    <div key={di} className={di > 0 ? "mt-4" : ""}>
                      <h5 className="fw-bold">{dur.duration}</h5>
                      {(dur.tiers || []).map((tier, ti) => (
                        <div key={ti} className="mb-3">
                          <div className="fw-semibold mb-1">
                            {tier.label}{tier.pax_note ? ` (${tier.pax_note})` : ""}
                          </div>
                          <table className="table table-sm table-bordered mb-0">
                            <tbody>
                              {(tier.options || []).map((opt, oi) => (
                                <tr key={oi}>
                                  <td>{opt.name}</td>
                                  <td className="text-end">{opt.price != null ? `₹${Number(opt.price).toLocaleString()}/pax` : ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : null}

              {/* Hotel Info */}
              {/* <div className="p-4 border rounded bg-white">
                <h2 className="mb-4 border-bottom pb-2">Hotel Info</h2>
                {detailData?.Visit && detailData.Visit.length > 0 ? (
                  <ul className="list-unstyled">
                    {detailData.Visit.map((item, index) => (
                      <li key={index} className="mb-2 text-dark">{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-muted">No hotel info available.</p>
                )}
              </div> */}
            </div>

            {/* Right Column: Why Choose Us */}
            <div className="col-md-3 d-flex justify-content-center">
              <div
                className="card shadow-sm"
                style={{
                  width: "100%",
                  maxWidth: "288px",
              
                  borderRadius: "12px",
                }}
              >
              

                <div className="card-body text-center">
                  <h4 className="card-title">
                    <b>Enquiry</b>
                  </h4>
                  <h6 className="card-subtitle mb-2 ">
                    Want to know more contact us
                  </h6>
                  <h5>
                    <FontAwesomeIcon icon={faPhone} />{" "}
                    <a
                      style={{ color: "#03045E", textDecoration: "none" }}
                      href="tel:+91 7006363828"
                    >
                      +91 7006363828
                    </a>
                  </h5>
                </div>




              </div>
            </div>

          </div>
        </div>

        {/* add google map here  */}
        <div className="mb-5 mx-5">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
            <h2 className="mb-0">Where you'll stay</h2>
            <a
              href={buildMapDirectionsUrl(mapQuery)}
              target="_blank"
              rel="noreferrer"
              className="btn btn-dark btn-sm px-3 py-1 rounded-pill"
              style={{ fontSize: "0.8rem" }}
            >
              Get directions
            </a>
          </div>
          <iframe
            src={buildMapEmbedSrc(mapQuery, 12)}
            title={`Map showing the location of ${detailData?.name}`}
            className="w-100 d-block border-0"
            style={{ height: "360px", borderRadius: "10px" }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
          <p className="text-muted small mt-2 mb-0">
            Approximate location{detailData?.location ? ` in ${detailData.location}` : ""}. Call us
            for exact directions.
          </p>
        </div>
        {/* add google map here end */}

        <div className="mb-5 mx-5">
          <h2 className="mb-4">Explore More Resorts</h2>
          <div className="row" style={{ borderRadius: "10px" }}>
            {(relatedResorts || []).map((resort, i) => {
              const image = Array.isArray(resort?.image) ? resort.image[0] : resort?.image || "/placeholder.svg";
              const title = resort?.name || "Unnamed Resort";
              const description = resort?.location || "No description available.";
              return (
                <div className="col-md-3" key={i} style={{ padding: "10px" }}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="position-relative">
                      <img
                        src={image}
                        className="card-img-top"
                        alt={title}
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    </div>
                    <div className="card-body">
                      <h3 className="card-title" style={{ fontSize: '16px' }}>{title}</h3>
                      <p className="card-text small text-muted">{description.slice(0, 100)}...</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

        </div>

        <div className="container my-5">
          <div className="row align-items-center">
            {/* Left Column */}
            <div className="col-md-6 d-flex flex-column gap-3">
              <NavLink to="/contact-us" style={{ textDecoration: "none" }}>
                <button
                  style={{
                    width: "120px",
                    height: "50px",
                    borderRadius: "100px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: "#000",
                    backgroundColor: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Join Now
                </button>
              </NavLink>
              <h2 className="mb-0">Explore Leh Bike Expedition</h2>
            </div>

            {/* Right Column */}
            <div className="col-md-6">
              <p className="text-muted mb-0">
                Book your stay at Traveller Choice Ladakh—comfort, convenience, and stunning mountain views await your arrival.
              </p>
            </div>
          </div>
        </div>


        <div className="mt-4 text-center text-muted small">
          <p>{detailData?.footerNote || 'Adventure awaits. Make your ride legendary.'}</p>
        </div>
        <TravLadhak />
        <Footer />
      </div>
    </>

  );
};

export default DetailHotelPackage;